import request from '../utils/request'

export function loginSystem(params) {
  return request({
    url: '/syUser/loginEmp',
    method: 'post',
    data:params
  })
}


export function logOutSystem(params) {
  return request({
    url: '/syUser/logOut',
    method: 'post',
    data:params
  })
}


export function queryGetDataForNoon(params) {
  return request({
    url: '/stuEmp/getDataForNoon',
    method: 'post',
    data: params
  })
}

export function queryLogInSendCode(params) {
  return request({
    url: '/syUser/logInSendCode',
    method: 'post',
    data: params
  })
}

export function queryGetDataSummary(params) {
  return request({
    url: '/stuEmp/getDataSummary',
    method: 'post',
    data: params
  })
}

export function queryGetSignStu(params) {
  return request({
    url: '/stuEmp/getSignStu',
    method: 'post',
    data: params
  })
}

export function queryGetDataForNoonDetail(params) {
  return request({
    url: '/stuEmp/getDataForNoonDetail',
    method: 'post',
    data: params
  })
}

export function querySyFaceLogSelectPage(params) {
  return request({
    url: '/syFaceLog/selectPage',
    method: 'post',
    data: params
  })
}

export function querySyDayDishGetEatRecords(params) {
  return request({
    url: '/syDayDish/getEatRecordsPage',
    method: 'post',
    data: params
  })
}

export function queryBusinessUserSelectPage(params) {
  return request({
    url: '/businessUser/selectPage',
    method: 'post',
    data: params
  })
}

export function querySyPerformanceDetail(params) {
  return request({
    url: '/syPerformanceDetail/detail',
    method: 'post',
    data: params
  })
}

export function queryGetSignStuDetail(params) {
  return request({
    url: '/stuEmp/getSignStuDetail',
    method: 'post',
    data: params
  })
}

export function querySyPerformanceUpdate(params) {
  return request({
    url: '/syPerformanceDetail/update',
    method: 'post',
    data: params
  })
}


export function querySyPerformanceAdd(params) {
  return request({
    url: '/syPerformanceDetail/add',
    method: 'post',
    data: params
  })
}

export function querySyUserUpdateFace(params) {
  return request({
    url: '/syUser/updateFace',
    method: 'post',
    data: params
  })
}

export function querySyUserUpdate(params) {
  return request({
    url: '/stuDetail/addOrUpdate',
    method: 'post',
    data: params
  })
}

export function querySelectUserById(params) {
  return request({
    url: '/syUser/selectUserById?id=' + params.id,
    method: 'post',
    data: params
  })
}

export function queryProductList(params) {
  return request({
    url: '/product/selectByPage',
    method: 'post',
    data: params
  })
}

export function queryProductExchange(params) {
  return request({
    url: '/product/exchange',
    method: 'post',
    data: params
  })
}

export function queryScoresGetDetailsPage(params) {
  return request({
    url: '/scores/getDetailsPage',
    method: 'post',
    data: params
  })
}

export function queryScoresAddRecordse(params) {
  return request({
    url: '/scores/addRecords',
    method: 'post',
    data: params
  })
}

export function queryGetEnum(params) {
  return request({
    url: '/enum/getEnum',
    method: 'get',
    params,
  })
}

export function querySelectOrgListByUser(params) {
  return request({
    url: '/syOrg/selectOrgListByUser',
    method: 'post',
    data: params
  })
}

export function queryBusinessUserData(params) {
  return request({
    url: '/businessUser/businessData',
    method: 'post',
    data: params
  })
}

export function querySyDataStatisticsMainStats(params) {
  return request({
    url: '/syDataStatistics/mainStats',
    method: 'post',
    data: params
  })
}


export function querySyDataStatisticsMainDatas(params) {
  return request({
    url: '/syDataStatistics/mainDatas',
    method: 'post',
    data: params
  })
}




export function querySyDeviceSelectPage(params) {
  return request({
    url: '/syDevice/selectPage',
    method: 'post',
    data: params
  })
}


// 摄像头订阅直播流
export function queryMediaVideoSubscribeStreame(params) {
  return request({
    url: '/MediaVideo/SubscribeStream',
    method: 'post',
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 摄像头取消订阅直播流
export function queryMediaVideoUnSubscribeStream(params) {
  return request({
    url: '/MediaVideo/UnSubscribeStream',
    method: 'post',
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}



export function querySurveySelectSurveyById(params) {
  return request({
    url: '/survey/selectSurveyById',
    method: 'post',
    data: params
  })
}

// 提交问卷
export function querySurveyAddDetail(params) {
  return request({
    url: '/apply/addDetail',
    method: 'post',
    data: params
  })
}

export function querySyActivitySelectByIdDetail(params) {
  return request({
    url: '/syActivity/selectById',
    method: 'post',
    data: params
  })
}

// 摄像头心跳
export function queryMediaVideHeartbeat(params) {
  return request({
    url: '/MediaVideo/heartbeat',
    method: 'get',
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 摄像头订阅

export function queryMediaVideoSubscribe(params) {
  return request({
    url: '/MediaVideo/subscribe',
    method: 'post',
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 添加沟通记录
export function queryAddCommunication(params) {
  return request({
    url: '/contactRecords/add',
    method: 'post',
    data: params
  })
}

export function queryCommunicationRecords(params) {
  return request({
    url: '/contactRecords/page',
    method: 'post',
    data: params
  })
}


// 床位统计使用情况

export function postRoomBedUsageStats(params) {
  return request({
    url: '/syDataStatistics/roomBedUsageStats',
    method: 'post',
    data:params
  })
}


export function bedUserSelectPage(params) {
  return request({
    url: '/bedUser/selectPage',
    method: 'post',
    data: params
  })
}















